import {useTranslation} from 'react-i18next';
import IMG_500_LIGHT from '../../../public/static/v4/500/img-server-error-light.svg';
import IMG_500 from '../../../public/static/v4/500/img-server-error.svg';
import Text from '../../common/component/Text';
import TextButton from '../../common/component/TextButton';
import useTheme from '../../common/hook/useTheme';

interface IProps {
  errorCode?: number;
}

export default function Error500({errorCode}: IProps) {
  const {isLightMode} = useTheme();
  const {t} = useTranslation();

  return (
    <div
      className="h-full flex-center"
      style={{paddingBottom: BTN_HEIGHT + BTN_PADDING_BOTTOM}}
    >
      <div className="flex-col flex-center">
        <img src={isLightMode ? IMG_500_LIGHT : IMG_500} alt="500" />
        <Text className="mt-20 text-center s14-regular-white light:text-black">
          {t('error_server_popup_request')}
          {errorCode && <span className="hidden">{errorCode}</span>}
        </Text>
      </div>
      <div
        className="absolute w-full px-9"
        style={{bottom: BTN_PADDING_BOTTOM}}
      >
        <TextButton
          width="100%"
          height={`${BTN_HEIGHT}px`}
          className="border border-white border-solid rounded-25 light:border-black "
          textClassName="s16-bold-white flex-center light:text-black"
          onClick={() => {
            window.location.reload();
          }}
        >
          {t('common_error_retry')}
        </TextButton>
      </div>
    </div>
  );
}

const BTN_PADDING_BOTTOM = 30;
const BTN_HEIGHT = 50;
